<template>
   <div id="inicio" class="user-start-no">
      <div v-if="isMounted">
         <!-- PANEL DE CUMPLIMIENTO -->
         <compliance-banner @loadedRequirements="loadedRequirements" class="mb-base" />
         <!-- BANNER PROMO 10 AÑOS -->
         <template v-if="showTenAnniversaryBanner">
            <ten-anniversary-promo-banner class="mb-base mt-5" :active="tenAnniversaryBannerActive" />
         </template>
         <!-- SI EL INVERSIONISTA NO SE ENCUENTRA ENROLADO EN EL MERCADO SECUNDARIO -->
         <template v-if="!InvestorRegisteredOnSecondaryMarket">
            <template>
               <!-- RESUMEN DE INVERSIONES -->
               <div class="vx-row mt-base">
                  <div class="vx-col w-full">
                     <div class="flex items-end px-3">
                        <h2>Resumen de mis inversiones</h2>
                     </div>
                  </div>
               </div>
               <div class="vx-row">
                  <div class="vx-col lg:w-1/4 md:w-1/2 w-full">
                     <vx-card class="h-auto text-center mt-5">
                        <div class="vx-row">
                           <div class="vx-col w-full">
                              <img :src="figs.portfolio" style="width: 20%; display: unset;" alt="">
                              <h3 class="mt-5 mb-3">
                                 {{ explicitMoneyFormat(totalPortfolio) }} MXN
                              </h3>
                              <label>
                                 Valor del portafolio
                              </label>
                           </div>
                        </div>
                        <div class="vx-row mt-5">
                           <div class="vx-col w-full">
                              <vs-button class="mb-2" @click.stop="goToPortfolio">Ir al portafolio</vs-button>
                           </div>
                        </div>
                     </vx-card>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/2 w-full">
                     <vx-card class="h-auto text-center mt-5">
                        <div class="vx-row">
                           <div class="vx-col w-full">
                              <img :src="figs.invest" style="width: 20%; display: unset;" alt="">
                              <h3 class="mt-5 mb-3">
                                 {{ explicitMoneyFormat(availableToInvest) }} MXN
                              </h3>
                              <label>
                                 Disponible para inversión
                              </label>
                           </div>
                        </div>
                        <div class="vx-row mt-5">
                           <div class="vx-col w-full">
                              <vs-button class="mb-2" @click.stop="goToInvestments">Invertir</vs-button>
                           </div>
                        </div>
                     </vx-card>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/2 w-full">
                     <vx-card class="h-auto text-center mt-5">
                        <div class="vx-row">
                           <div class="vx-col w-full">
                              <img :src="figs.commitment" style="width: 20%; display: unset;" alt="">
                              <h3 class="mt-5 mb-3">
                                 {{ explicitMoneyFormat(investmentCommitments) }} MXN
                              </h3>
                              <label>
                                 Compromisos de inversión
                              </label>
                           </div>
                        </div>
                        <div class="vx-row mt-5">
                           <div class="vx-col w-full">
                              <vs-button class="mb-2" @click.stop="goToInvestorProjects">Ir a proyectos</vs-button>
                           </div>
                        </div>
                     </vx-card>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/2 w-full">
                     <vx-card class="h-auto text-center mt-5">
                        <div class="vx-row">
                           <div class="vx-col w-full">
                              <img :src="figs.fixed" style="width: 20%; display: unset;" alt="">
                              <h3 class="mt-5 mb-3">
                                 {{ explicitMoneyFormat(activeFixedInvestment) }} MXN
                              </h3>
                              <label>
                                 Inversión efectiva
                              </label>
                           </div>
                        </div>
                        <div class="vx-row mt-5">
                           <div class="vx-col w-full">
                              <vs-button class="mb-2" @click.stop="goToInvestorProjects">Ver más</vs-button>
                           </div>
                        </div>
                     </vx-card>
                  </div>
               </div>
               <div class="vx-row mt-5">
                  <div class="vx-col w-full">
                     <div class="flex">
                        <feather-icon icon="InfoIcon" svgClasses="w-8 h-8 text-primary" class="mr-3" />
                        <span class="bold mt-1 italic">El valor de tu portafolio es la suma del saldo disponible para
                           inversión, los
                           compromisos de inversión y el monto de inversión efectiva.</span>
                     </div>
                  </div>
               </div>
            </template>
            <div class="vx-row">
               <!-- BANNER AUMENTA TU NIVEL -->
               <div class="vx-col lg:w-3/4 w-full mb-1 mt-5" v-if="mainComplianceRequirements <= 0">
                     <vx-card v-if="isMounted">
                        <investor-contract-level-banner />
                     </vx-card>
               </div>
               <!-- CARD INVERSION AUTOMATICA -->
               <div class="vx-col lg:w-1/4 w-full mb-1 mt-5">
                  <vx-card style="height: 100%;">
                     <div class="flex justify-between flex-wrap small-flex mt-1">
                        <h4 class="bold">Inversión automática</h4>
                        <automatic-investment-button class="mt-1" />
                     </div>
                     <div class="vx-row">
                        <div class="vx-col w-full">
                           <p class="mt-5">
                              Invierte tu dinero
                              automáticamente y crece
                              de manera exponencial.
                           </p>
                        </div>
                     </div>
                  </vx-card>
               </div>
            </div>
         </template>
         <!-- SI EL INVERSIONISTA YA SE ENCUENTRA EN EL MERCADO SECUNDARIO -->
         <template v-else>
            <!-- BANNER AVISOS LIMITES MERCADO SECUNDARIO -->
            <template>
               <!-- si el usuario no ha invertido -->
               <template v-if="!alreadyInvested">
                  <vx-card v-if="activeFixedInvestment <= 0" class="mb-base mt-5" card-background="#E4E4E4">
                     <div class="vx-row">
                        <div class="vx-col w-full">
                           <div slot="header" class="flex flex-wrap items-center flex-grow justify-between">
                              <div class="vx-row mt-3 mb-3" style="display: unset;">
                                 <div class="vx-col">
                                    <h2 class="bold">Haz tu primera inversión</h2>
                                 </div>
                                 <div class="vx-col">
                                    <label>
                                       Abona a tu cuenta de inversión las veces que desees y alcanza el mínimo de {{ explicitMoneyFormat(minFixedInvestmentRequiredToSignUpSm) }} y comienza a invertir.
                                    </label>
                                 </div>
                              </div>
                              <pay-funds-btn class="ml-auto" :button-type="'border'" :button-color="'dark'"></pay-funds-btn>
                           </div>
                        </div>
                     </div>
                  </vx-card>
               </template>
               <!-- si el usuario ya invirtio y esta por debajo del minimo a entrar al ms -->
               <vx-card v-else-if="!minInvestmentToSecondaryMarketReached" class="mb-base mt-5"
                  card-background="#E4E4E4">
                  <div class="vx-row">
                     <div class="vx-col w-full">
                        <div slot="header" class="flex flex-wrap items-center flex-grow justify-between">
                           <div class="vx-row mt-3 mb-3" style="display: unset;">
                              <div class="vx-col">
                                 <h2 class="bold">Te faltan {{
                                    explicitMoneyFormat(minInvestmentToSecondaryMarket) }}
                                    para alcanzar el mínimo de inversión</h2>
                              </div>
                              <div class="vx-col">
                                 <label>Alcanzar el mínimo es importante para que tu portafolio pueda
                                    diversificarse</label><br>
                                 <label>Si el valor de tu inversión no alcanza al menos {{
                                    explicitMoneyFormat(minFixedInvestmentRequiredToSignUpSm) }}, retiraremos tu
                                    inversión y será transferida a tu cuenta bancaria.</label>
                              </div>
                           </div>
                           <pay-funds-btn class="ml-auto" :button-type="'border'" :button-color="'dark'"></pay-funds-btn>
                        </div>
                     </div>
                  </div>
               </vx-card>
            </template>

            <!-- BANNER MI CUENTA DE INVERSION -->
            <vx-card class="mt-base mb-base">
               <div class="vx-row">
                  <div class="vx-col w-full">
                     <h1 class="mt-5">Mi cuenta de inversión</h1>
                  </div>
               </div>
               <div class="vx-row mb-base">
                  <!-- valor de mi portafolio -->
                  <div class="vx-col xl:w-1/2 w-full p-5">
                     <div class="vx-row" style="background-color: #D9D9D933; border-radius: 20px; height: 100%;">
                        <div class="vx-col w-full mt-base mb-base">
                           <div class="flex flex-wrap items-center flex-grow justify-center" style="height: 100%;">
                              <img src="https://cdn.redgirasol.com/investors/home/portfolio-icon.png"
                                 style="width: 120px" alt="" class="mr-5">
                              <div class="vx-row">
                                 <div class="vx-col">
                                    <h2 class="bold">{{ explicitMoneyFormat(totalPortfolio) }}</h2>
                                    <p class="h3-normal">Valor de mi cuenta</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="vx-col w-full">
                           <label class="bold">Resumen de mi portafolio</label>
                           <div class="vx-row">
                              <div class="vx-col w-1/3 p-5">
                                 <p class="bold">{{ explicitMoneyFormat(activeFixedInvestment) }}</p>
                                 <p>Inversión efectiva</p>
                              </div>
                              <div class="vx-col w-1/3 p-5">
                                 <p class="bold">{{ explicitMoneyFormat(availableToInvest) }}</p>
                                 <p>Saldo disponible</p>
                              </div>
                              <div class="vx-col w-1/3 p-5">
                                 <p class="bold">{{ explicitMoneyFormat(investmentCommitments) }}</p>
                                 <p>Compromiso de inversión</p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <!-- rendidmientos generados -->
                  <div class="vx-col xl:w-1/2 w-full p-5">
                     <div class="vx-row" style="background-color: #D9D9D933; border-radius: 20px; height: 100%;">
                        <div class="vx-col w-full mt-base mb-base">
                           <div class="flex flex-wrap items-center flex-grow justify-start ml-5" style="height: 100%;">
                              <img src="https://cdn.redgirasol.com/investors/home/returns-icon.png" style="width: 120px"
                                 alt="" class="mr-5">
                              <div class="vx-row">
                                 <div class="vx-col">
                                    <h2 class="bold">{{ explicitMoneyFormat(generatedReturns) }}</h2>
                                    <p class="h3-normal">Rendimientos generados</p>
                                    <small>después de impuestos y comisiones.</small>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="vx-col w-full">
                           <div class="vx-row mt-base">
                              <div class="vx-col w-full p-5">
                                 <div class="flex flex-wrap items-center flex-grow justify-start mb-1">
                                    <div class="mr-2" v-for="(item, index) in periodReturnsOptions" :key="index">
                                       <rg-radio class="w-full" groupName="periodReturnsOptions" :label="item.label"
                                          :value="item.value" :desc="item.desc" v-model="periodReturns" />
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="vx-row mt-base mb-base">
                  <div class="vx-col w-full">
                     <div class="flex justify-center px-3">
                        <pay-funds-btn class="pulse-success"></pay-funds-btn>
                        <vs-button class="ml-5" color="primary" type="border" :disabled="mainComplianceRequirements > 0"
                           @click.stop="popUpWithdrawFunds = true">Retirar</vs-button>
                     </div>
                  </div>
               </div>
            </vx-card>

            <!-- FILA PREVIO A FOOTER -->
            <div class="vx-row">
               <div :class="dinamicColIfMarketMaker">
                  <vx-card style="height: 100%;">
                     <monthly-auto-invest-banner :show-carousel="false"/>
                  </vx-card>
               </div>
               <div :class="dinamicColIfMarketMaker">
                  <!-- BANNER PORTAFOLIO RG -->
                  <rg-portfolio-banner style="height: 100%;"/>
               </div>
               <div v-if="IsInvestorMarketMaker" :class="dinamicColIfMarketMaker">
                  <vx-card style="height: 100%;">
                     <div class="flex flex-wrap justify-between mt-5">
                        <h3 class="bold">Compra de participación automática</h3>
                        <investment-mechanism-enabled-button class="mt-1" :current-investment-mechanism="user.investment_mechanism_enabled"/>
                     </div>
                     <div class="vx-row">
                        <div class="vx-col w-full">
                           <p class="mt-5">
                              Invierte tu dinero
                              automáticamente y crece
                              de manera exponencial.
                           </p>
                        </div>
                     </div>
                  </vx-card>
               </div>
            </div>
            
            <!-- BANNER INFO PORTAFOLIO -->
            <div class="vx-row">
               <div class="vx-col w-full">
                  <div class="flex">
                     <feather-icon icon="InfoIcon" svgClasses="w-8 h-8 text-primary" class="mr-3" />
                     <span class="bold mt-1 italic">El valor de tu portafolio es la suma del saldo disponible para
                        inversión, los
                        compromisos de inversión y el monto de inversión efectiva.</span>
                  </div>
               </div>
            </div>
         </template>
      </div>

      <!-- Popup para ver datos para retirar fondos -->
      <vs-popup v-if="popUpWithdrawFunds" :active.sync="popUpWithdrawFunds" title="Retirar"
         class="header-primary">
         <withdraw-info-sm-pop-up @on-saved="onWithdrawalSaved" @on-closed="onWithdrawalClosed" />
      </vs-popup>

      <!-- Popup para explicar la inversion evergreen solo aplica a MS (solo se muestra la primera vez que el inversionista inicia sesión) -->
      <vs-popup v-if="firstLoginPopupActive" :active.sync="firstLoginPopupActive" title="Inversión Evergreen"
         class="header-primary">
         <evergreen-info-pop-up :new-registered-user="!alreadyInvested" @on-closed="firstLoginPopupActive = false" />
      </vs-popup>

      <!-- Componente para obtener la geolocalización -->
      <rg-geolocator ref="rgGeolocator" />
      <!-- TERMINA INVITACION A MERCADO SECUNDARIO -->
   </div>
</template>

<script>

import ComplianceBanner from "@components/compliance/ComplianceBanner";
import formatHelper from "@mixins/formatHelper";
import stpHelper from "@mixins/stpHelper";
import dateHelper from "@mixins/dateHelper";
import userIdentityHelper from "@/helpers/userIdentityHelper";
import investorInfoHelper from "@/helpers/investorInfoHelper";
import FundReady from "@components/compliance/FundReady";
import { mapState } from "vuex";
import InvestorContractLevelBanner from "@components/investor/plans/InvestorContractLevelBanner";
import AutomaticInvestmentButton from "@components/investor/plans/AutomaticInvestmentButton";
import LatestInvestorMerchantContract from "@views/investor/contracts/LatestInvestorMerchantContract.vue";
import LatestAutomaticInvestmentTermsConditionsContract from "@views/investor/contracts/LatestAutomaticInvestmentTermsConditionsContract.vue";
import StpAccountInfoMinimal from "@components/stp/StpAccountInfoMinimal";
import WithdrawInfoSmPopUp from "@components/investor/invested/WithdrawInfoSmPopUp";
import RgPortfolioBanner from "@components/investor/secondary-market/RgPortfolioBanner";
import MonthlyAutoInvestBanner from "@components/investor/plans/MonthlyAutoInvestBanner";
import PayFundsBtn from '@components/investor/widgets/PayFundsBtn.vue';
import InvestmentMechanismEnabledButton from "@components/investor/secondary-market/InvestmentMechanismEnabledButton";
import TenAnniversaryPromoBanner from "@components/investor/widgets/TenAnniversaryPromoBanner";
import EvergreenInfoPopUp from "@components/investor/invested/EvergreenInfoPopUp";

const periodOptions = [
    { label: "Mes actual", value: "current", desc: null },
    { label: "Mes anterior", value: "month", desc: null },
    { label: "Últimos 12 meses", value: "year", desc: null },
];

export default {
   components: {
      ComplianceBanner,
      FundReady,
      InvestorContractLevelBanner,
      AutomaticInvestmentButton,
      LatestInvestorMerchantContract,
      LatestAutomaticInvestmentTermsConditionsContract,
      StpAccountInfoMinimal,
      WithdrawInfoSmPopUp,
      RgPortfolioBanner,
      MonthlyAutoInvestBanner,
      PayFundsBtn,
      InvestmentMechanismEnabledButton,
      TenAnniversaryPromoBanner,
      EvergreenInfoPopUp
   },
   mixins: [formatHelper, stpHelper, dateHelper, userIdentityHelper, investorInfoHelper],
   data() {
      return {
         periodReturnsOptions: periodOptions,
         isMounted: false,
         requirements: [],
         identity: null,
         identityStatus: 0,
         funds: 0,
         hasAutomaticInvestmentInactive: false,
         showInvestmentCard: false,
         stpClabe: null,
         user_person_type: null,
         availableToInvest: 0,
         investmentCommitments: 0,
         activeFixedInvestment: 0,
         totalPortfolio: 0,
         generatedReturns:0,
         periodReturns:'month',
         minFixedInvestmentRequiredToSignUpSm: 0,
         minFinalBalanceRequiredToSignUpSm: 0,
         alreadyInvested: false,
         figs: {
            arrows: require('@assets/images/investor-figs/home-arrows-up.svg'),
            portfolio: require('@assets/images/investor-figs/home-portfolio.svg'),
            invest: require('@assets/images/investor-figs/home-invest.svg'),
            commitment: require('@assets/images/investor-figs/home-commitment.svg'),
            fixed: require('@assets/images/investor-figs/home-fixed-investment.svg'),
         },
         mainComplianceRequirements: 0,
         popUpWithdrawFunds: false,
         firstLoginPopupActive: false,
      }
   },
   computed: {
      ...mapState("auth", ["roleGeneralData"]),
      isMexicanPM() {
         return this.user_person_type === 0;
      },
      isMexicanPF() {
         return this.user_person_type === 1;
      },
      minInvestmentToSecondaryMarket() {
         return this.minFixedInvestmentRequiredToSignUpSm - this.activeFixedInvestment - this.availableToInvest;
      },
      minInvestmentToSecondaryMarketReached() {
         return this.minInvestmentToSecondaryMarket <= 0;
      },
      dinamicColIfMarketMaker(){
         return this.IsInvestorMarketMaker? "vx-col lg:w-1/3 w-full mb-base":"vx-col lg:w-1/2 w-full mb-base";
      },
      showTenAnniversaryBanner() {
         return !!this.OfferBanners && this.OfferBanners.some(banner => banner.slug === "decimo_aniversario_2026");
      },
      tenAnniversaryBannerActive() {
         return !!this.OfferBanners && this.OfferBanners.some(banner => banner.slug === "decimo_aniversario_2026" && banner.status === "active");
      }
   },
   watch:{
      periodReturns: async function (old, newval){
      if(old !== newval){
        await this.postInvestorReturns();
      }
    },
      firstLoginPopupActive(isActive) {
         if (!isActive) {
            this.markFirstLoginPopupAsSeen();
         }
      }
   },
   async beforeMount() {
      this.user_person_type = parseInt(this.UserPersonType);
   },
   async mounted() {
      // si es necesario mostrar el onboarding no se termina de cargar el componente porque no es necesario      
      if (this.ShowInvestorOnboarding || this.ShowInvestorOnboardingForUpdate) {
         return;
      }
      this.isMounted = false;
      await this.showLoading(true)
      await this.onUserInfoUpdated();
      await this.getDataForHome();
      // solo se llama si el inversionista esta en MS
      if (this.InvestorRegisteredOnSecondaryMarket) {
         await this.postInvestorReturns();
      }
      // await this.getPlansInfo();
      await this.checkForStpInfo();
      await this.setCardsSettings();
      // if (this.InvestorRegisteredOnSecondaryMarket && !this.alreadyInvested) {
      //    this.showSecondaryMarketCarousel=true;
      // }
      this.isMounted = true
      await this.showLoading(false)
      this.checkFirstLoginPopup();
   },
   methods: {
      firstLoginPopupStorageKey() {
         return `investor_first_login_popup_seen_${this.InvestorId}`;
      },
      checkFirstLoginPopup() {
         try {
            if (this.InvestorRegisteredOnSecondaryMarket && !localStorage.getItem(this.firstLoginPopupStorageKey())) {
               this.firstLoginPopupActive = true;
            }
         }
         catch (e) {
            // localStorage no disponible (modo incógnito estricto, storage deshabilitado, etc.)
         }
      },
      markFirstLoginPopupAsSeen() {
         try {
            localStorage.setItem(this.firstLoginPopupStorageKey(), '1');
         }
         catch (e) {
            // localStorage no disponible (modo incógnito estricto, storage deshabilitado, etc.)
         }
      },
      async getDataForHome() {
         try {
            let response = await axios.get(`api/v2/investor/${this.InvestorId}/get-data-for-home-page-ms`);

            // DATOS PARA VERSION ACTUAL DE HOME
            this.identity = response.data.identity;
            this.availableToInvest = response.data.availableToInvest;
            this.investmentCommitments = response.data.investmentCommitments;
            this.activeFixedInvestment = response.data.activeFixedInvestment;
            this.totalPortfolio = response.data.totalPortfolio;
            this.minFixedInvestmentRequiredToSignUpSm = response.data.minFixedInvestmentRequiredToSignUpSm;
            this.minFinalBalanceRequiredToSignUpSm = response.data.minFinalBalanceRequiredToSignUpSm;
            this.alreadyInvested = response.data.alreadyInvested;

            // SE VALIDAN DATOS PARA MOSTRAR O NO EL BANNER DE LA VERIFICACION DE IDENTIDAD
            if (this.identity) {
               this.identityStatus = this.identity.identity_status;
            }
         }
         catch (e) {
            this.warn(e);
         }
      },
      async postInvestorReturns() {
         await this.showLoading(true);
         try {
            let payload = {
               "period": this.periodReturns
            };
            let response = await axios.post(`api/v2/investor/generated-returns`, payload);
            this.generatedReturns = response.data.generated_returns;
         }
         catch (e) {
            this.warn(e);
         }
         await this.showLoading(false);
      },
      async changePeriodGeneratedReturns(period) {
         try {
            this.periodReturns = period;
            await this.postInvestorReturns();
         }
         catch (e) {
            this.warn(e);
         }
      },
      async getPlansInfo() {
         try {
            const res = await axios.get(`api/v2/investor/${this.InvestorId}/getInvestorPlansInfo`);
            const investorPlan = res.data.plan;
            this.hasAutomaticInvestmentInactive = investorPlan.autoinvest_applicant_payments === 0;
         }
         catch (e) {
         }
      },
      async checkForStpInfo() {
         // solicitar informacion de stp solo si corresponde
         // panel completo y persona fisica mexicana
         if (this.isMexicanPF || this.isMexicanPM) {
            this.stpClabe = await this.getInvestorAccountStpClabe(this.InvestorId);
         }
      },
      async setCardsSettings() {
         // tarjeta: abonar fondos
         // Aparece cuando su saldo es igual a 0 y tiene clabe stp
         if (this.roleGeneralData.balance === 0 && this.stpClabe !== null) {
            this.showInvestmentCard = true;
            // this.$router.replace({name: 'abonarFondos'});
            return;
         }
      },
      async goToWithdrawFunds() {
         await this.$router.push({ name: 'retirarFondos' });
      },
      loadedRequirements(count) {
         this.mainComplianceRequirements = count;
      },
      async onWithdrawalSaved() {
         this.popUpWithdrawFunds = false;
         await this.showLoading(true)
         await this.onUserInfoUpdated();
         await this.getDataForHome();
         await this.showLoading(false);
      },
      async onWithdrawalClosed() {
         this.popUpWithdrawFunds = false;
      },
      async goToPortfolio() {
         await this.$router.push({ name: 'miPortafolio' });
      },
      async goToInvestments() {
         await this.$router.push({ name: 'oportunidades' });
      },
      async goToInvestorProjects() {
         await this.$router.push({ name: 'misProyectosInversionista' });
      }
   }
};
</script>

<style scoped>
.big-label {
   font-size: 24px;
}

.big-label-sub {
   font-size: 20px;
}

.checkbox-display {
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-content: flex-start;
}

li {
  list-style-type: disc;
}
</style>
